import { GoalContent as GoalContentComponent } from './GoalContent.component';
import { connector } from './GoalContent.connector';

export const GoalContent = connector(GoalContentComponent);
